import * as THREE from 'three';

export const FRONT_VISIBILITY_GROUP_NAMES = {
  framing: 'detail/front-visibility/framing',
  panel: 'detail/front-visibility/panel',
  roof: 'detail/front-visibility/roof',
  interior: 'detail/front-visibility/interior',
  exterior: 'detail/front-visibility/exterior',
} as const;

export type FrontVisibilityLayer = keyof typeof FRONT_VISIBILITY_GROUP_NAMES;
export type FrontVisibilityGroups = Partial<Record<FrontVisibilityLayer, THREE.Group>>;

export function createFrontVisibilityGroup(
  layer: FrontVisibilityLayer,
  parent: THREE.Group,
): THREE.Group {
  const group = new THREE.Group();
  group.name = FRONT_VISIBILITY_GROUP_NAMES[layer];
  parent.add(group);
  return group;
}

export function getFrontVisibilityGroup(
  root: THREE.Group,
  layer: FrontVisibilityLayer,
): THREE.Group | null {
  const group = root.getObjectByName(FRONT_VISIBILITY_GROUP_NAMES[layer]);
  return group instanceof THREE.Group ? group : null;
}

const DIVIDER_VISIBILITY_GROUP_NAME = 'detail/divider-visibility';

export function createDividerVisibilityGroup(parent: THREE.Group): THREE.Group {
  const group = new THREE.Group();
  group.name = DIVIDER_VISIBILITY_GROUP_NAME;
  parent.add(group);
  return group;
}

export function applyDividerVisibility(root: THREE.Group | undefined, visible: boolean): void {
  root?.traverse(node => {
    if (node.name === DIVIDER_VISIBILITY_GROUP_NAME) node.visible = visible;
  });
}
